<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  [preserveContent]="true">
  <mat-tab label='Process'>
    <mat-card class='mat-elevation-z8 job-information-card'>
      @if (job(); as selectedJob) {
        <fieldset class='job-information-title'>
          <legend>{{selectedJob.name}} - {{selectedJob.jobTaskTemplateName}}</legend>
        </fieldset>
        <app-gateway-details [(gateways)]='gateways'
          [job]='selectedJob'
          (jobChange)='job.set($event)'
          [exportStatus]="exportStatus()"
          (jobStartEnabled)='onJobStartStateChanged($event)'
          (exportCompleteEvent)='onExportStatusChanged($event)' />
        <app-job-tasks [job]='selectedJob'
          [tasks]='tasks()'
          [(jobStartEnabled)]='jobStartEnabled' />
      }
    </mat-card>
  </mat-tab>
  <mat-tab label='Notifications'>
    <mat-card class='mat-elevation-z8 job-information-card'>
      <div class="job-information-notifications">
        <div class='job-information-notification-actions'>
          <button
            class='job-information-clear-otap-notifications-button'
            mat-raised-button
            (click)='clearOtapNotifications()'
            color='accent'
            type='button'
            [attr.data-cy]="'clear-otap-notifications'">
            <span class='or-button-label'>Clear</span>
          </button>
          <button
            mat-button
            type='button'
            (click)='toggleNotifications(notificationAccordion)'
            [attr.aria-label]="notificationsExpanded() ? 'Collapse all notifications' : 'Expand all notifications'"
            [attr.data-cy]="'toggle-otap-notifications'">
            {{ notificationsExpanded() ? 'Collapse All' : 'Expand All' }}
          </button>
          <button
            mat-button
            type='button'
            (click)='copyOtapNotifications()'
            [attr.data-cy]="'copy-otap-notifications'">
            Copy all notifications
          </button>
        </div>
        <mat-accordion
          #notificationAccordion="matAccordion"
          class='otap-notification-headers-align'
          multi>
          @for (otapNotification of otapNotifications(); track otapNotification) {
            <div>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ otapNotification.timestamp }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{ otapNotification.gateway }}
                  </mat-panel-description>
                  <button
                    mat-icon-button
                    type='button'
                    (click)='copyOtapNotification($event, otapNotification)'
                    [attr.aria-label]="'Copy notification from ' + otapNotification.gateway"
                    [attr.data-cy]="'copy-otap-notification-' + otapNotification.gateway">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </mat-expansion-panel-header>
                <code>
                  <pre>{{ otapNotification.message | json }}</pre>
                </code>
              </mat-expansion-panel>
            </div>
          }
        </mat-accordion>
      </div>
    </mat-card>
  </mat-tab>
</mat-tab-group>
